<template>
  <v-container grid-list-xl>
    <admin-navigation></admin-navigation>
    <br/>
    <v-card class="elevation-0">
      <v-card-title
        class="ma-0 pa-4 orange lighten-3 font-weight-black headline"
        style="overflow: hidden"
      >
        <span class="ml-4" style="text-transform: uppercase;">Equipment Pricing</span>
      </v-card-title>
      <v-card-text class="pt-4 px-1">
        <v-container fluid>
          <v-row>
            <v-col cols="12" md="12" class="pa-0" v-if="loading">
              <v-skeleton-loader type="table"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" md="12" class="pa-0" v-else>
              <v-data-table
                dense
                :items="filteredEquipment"
                :loading="loading"
                loading-text="Loading....please wait."
                :headers="headers"
                :search="search"
              >
                <template v-slot:top>
                  <v-row class="px-2 pt-3 pb-2" align="center" no-gutters>
                    <v-col cols="12" sm="6" md="4" class="pr-2">
                      <v-select
                        v-model="selectedCategories"
                        :items="categories"
                        item-text="name"
                        item-value="category"
                        label="Categories"
                        multiple
                        outlined
                        dense
                        hide-details
                      >
                        <template v-slot:selection="{ item, index }">
                          <span v-if="index === 0">{{ item.name }}</span>
                          <span
                            v-if="index === 1"
                            class="grey--text caption"
                          >
                            (+{{ selectedCategories.length - 1 }} others)
                          </span>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" class="pr-2">
                      <v-text-field
                        v-model="search"
                        label="Filter by product name or unit price"
                        clearable
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:item.Elite="{ item }">
                  <v-text-field
                    class="my-1"
                    outlined
                    dense
                    hide-details
                    v-model.number="item.Elite"
                    type="number"
                  ></v-text-field>
                </template>
                <template v-slot:item.inactive="{ item }">
                  <v-switch
                    :input-value="!item.inactive"
                    @change="item.inactive = !$event"
                    hide-details
                    dense
                    class="mt-0"
                  ></v-switch>
                </template>
                <template v-slot:item.save="{ item }">
                  <v-btn
                    color="primary"
                    outlined
                    text
                    @click="updatePrice(item)"
                    >save</v-btn
                  >
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snack = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import fb from "@/main";
import AdminNavigation from "@/components/AdminNavigation.vue";
import { productCategories } from "@/helpers";

export default {
  components: {
    AdminNavigation
  },
  name: "Home",
  data() {
    return {
      loading: true,
      equipment: [],
      selectedCategories: ["Outdoor"],
      search: "",
      snack: false,
      snackColor: "",
      snackText: "",
      categories: [...productCategories],
      headers: [
        {
          text: "Model",
          value: "model",
        },
        {
          text: "Description",
          sortable: false,
          value: "description",
        },
        { text: "Unit Price", value: "Elite", align: "center", width: "140" },
        { text: "Active", value: "inactive", align: "center", width: "100" },
        { text: "", value: "save", align: "end", width: "100" },
      ],
    };
  },
  async created() {
    try {
      this.unsubscribeDemobs = await fb.db
        .collection("equipment")
        .onSnapshot((querySnapshot) => {
          let equipment = [];
          querySnapshot.forEach(function (doc) {
            equipment.push({
              id: doc.id,
              ...doc.data(),
            });
          });
          this.equipment = equipment;
        });
      this.loading = false;
    } catch (error) {
      this.loading = false;
      if (error.message === "Missing or insufficient permissions.") {
        this.$router.push("/");
      } else {
        alert("Error loading companies.");
      }
    }
  },
  computed: {
    filteredEquipment() {
      return this.equipment.filter((e) =>
        this.selectedCategories.includes(e.category)
      );
    },
  },
  methods: {
    async updatePrice(item) {
      await fb.db.collection("equipment").doc(item.id).update({
        Elite: item.Elite,
        inactive: item.inactive || false,
      });
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Successfully saved.";
    },
  },
};
</script>
<style>
tbody tr:hover {
  background-color: transparent !important;
}
</style>
